import React from "react";
import { T } from "../../app/tokens.js";
import { INCOMING_AXIS_TICKS } from "./incomingRunway.js";

export function IncomingRunway({ model, leaseId }) {
  if (!model.usable) return <div data-testid={`incoming-runway-fallback-${leaseId}`} />;
  return (
    <div data-testid={`incoming-runway-${leaseId}`} aria-hidden="true"
      style={{ position: "relative", height: 28, margin: "0 6px" }}>
      <div style={{ position: "absolute", top: 11, left: 0, right: 0, height: 7, background: T.hair, borderRadius: 4 }} />
      {INCOMING_AXIS_TICKS.map(({ days }, i) => (
        <div key={days} style={{ position: "absolute", top: 4, left: `${(i + 1) * 20}%`, width: 1, height: 18, background: T.line }} />
      ))}
      {model.future && <div data-testid={`incoming-lead-${leaseId}`}
        style={{ position: "absolute", top: 13, left: 0, width: `${model.leadWidth}%`, borderTop: `2px dashed ${T.light}` }} />}
      {model.termWidth > 0 && <div data-testid={`incoming-term-${leaseId}`}
        style={{ position: "absolute", top: 11, left: `${model.startPct}%`, width: `${model.termWidth}%`, height: 7, borderRadius: 4, background: T.buildBlue }} />}
      {model.markerVisible && <div data-testid={`commencement-marker-${leaseId}`}
        style={{ position: "absolute", top: 7, left: `${model.startPct}%`, width: 11, height: 11, boxSizing: "border-box", borderRadius: "50%", background: T.white, border: `2px solid ${T.buildBlue}`, transform: "translateX(-50%)" }} />}
      {model.capped && <span data-testid={`incoming-continuation-${leaseId}`}
        style={{ position: "absolute", top: 4, right: -3, color: T.buildBlue, background: T.card, fontSize: T.fsMd, fontWeight: T.fwBold }}>»</span>}
    </div>
  );
}
